import { RootState } from "@/store";
import { setIsDefaultDateOfBirth } from "@/store/userSlice";
import { getDecodedTokenSafe } from "@/utils/tokenUtils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INITIAL_USER_DATA } from "../constants";
import { UserBenefitData } from "../types";

export const useUserBenefits = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const [userData, setUserData] = useState<UserBenefitData>(INITIAL_USER_DATA);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const checkIfDefaultDOB = (date: string): boolean => {
    return !date;
  };

  const fetchUserBenefits = () => {
    try {
      setIsLoading(true);
      setError(null);

      const decodedToken = getDecodedTokenSafe<UserBenefitData>(() => {
        setError("Failed to fetch your account information");
      });

      if (decodedToken) {
        if (
          user.isDefaultDateOfBirth === null ||
          user.isDefaultDateOfBirth === true
        ) {
          const isDefault = checkIfDefaultDOB(decodedToken.DateOfBirth);
          dispatch(setIsDefaultDateOfBirth(isDefault));
        }

        setUserData({ ...INITIAL_USER_DATA, ...decodedToken });
      }
    } catch {
      setError("Failed to fetch user benefits");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserBenefits();
  }, []);

  return {
    userData,
    isLoading,
    error,
    refetch: fetchUserBenefits,
    checkIfDefaultDOB,
  };
};
